import { useAxiosModule } from '@/modules/_shared/axios'
import * as types from './types'

const {
    getFromApi,
    postToApi,
    patchToApi,
    putToApi,
    deleteInApi
} = useAxiosModule()

/* Get Billing Templates List */

export type GetBillingTemplatesListResponse = types.BillingTemplatesListModel[]
export async function getBillingTemplatesList (organizationId: string) {
    return getFromApi<GetBillingTemplatesListResponse>(`organizations/${organizationId}/billing-templates`)
}

/* Get Billing Template */

export type GetBillingTemplateResponse = types.GetBillingTemplate
export async function getBillingTemplate (organizationId: string, billingTemplateId: string) {
    return getFromApi<GetBillingTemplateResponse>(`organizations/${organizationId}/billing-templates/${billingTemplateId}`)
}

/* Mark as default */

export type MarkDefaultBillingTemplateRequest = types.MarkDefaultBillingTemplate
export async function markBillingTemplateAsDefault (organizationId: string, billingTemplateId: string, req: MarkDefaultBillingTemplateRequest) {
    return patchToApi<null>(`organizations/${organizationId}/billing-templates/${billingTemplateId}/mark-as-default`, req)
}

/* Add Mail Billing Template */

export type AddMailBillingTemplateRequest = types.AddBasicBillingTemplate
export async function addMailBillingTemplate (organizationId: string, req: AddMailBillingTemplateRequest) {
    return postToApi<null>(`organizations/${organizationId}/billing-templates/mail`, req)
}

/* Add Email Billing Template */

export type AddEmailBillingTemplateRequest = types.AddEmailBillingTemplate
export async function addEmailBillingTemplate (organizationId: string, req: AddEmailBillingTemplateRequest) {
    return postToApi<null>(`organizations/${organizationId}/billing-templates/email`, req)
}

/* Add Electronic Billing Template */

export type AddElectronicBillingTemplateRequest = types.AddElectronicBillingTemplate
export async function addElectronicBillingTemplate (organizationId: string, req: AddElectronicBillingTemplateRequest) {
    return postToApi<null>(`organizations/${organizationId}/billing-templates/electronic`, req)
}

/* Delete Billing Template */

export async function deleteBillingTemplate (organizationId: string, billingTemplateId: string) {
    return deleteInApi<null>(`organizations/${organizationId}/billing-templates/${billingTemplateId}`)
}

/* Change billing template name */

export type UpdateBillingTemplateNameRequest = types.ChangeBillingTemplateName
export async function updateBillingTemplateName (organizationId: string, billingTemplateId: string, req: UpdateBillingTemplateNameRequest) {
    return patchToApi<null>(`organizations/${organizationId}/billing-templates/${billingTemplateId}/change-template-name`, req)
}

/* Change Organization name */

export type UpdateOrganizationNameRequest = types.ChangeOrganizationName
export async function updateOrganizationName (organizationId: string, billingTemplateId: string, req: UpdateOrganizationNameRequest) {
    return patchToApi<null>(`organizations/${organizationId}/billing-templates/${billingTemplateId}/change-organization-name`, req)
}

/* Change business id */

export type UpdateBusinessIdRequest = types.ChangeBusinessId
export async function updateBusinessId (organizationId: string, billingTemplateId: string, req: UpdateBusinessIdRequest) {
    return patchToApi<null>(`organizations/${organizationId}/billing-templates/${billingTemplateId}/change-business-id`, req)
}

/* Change vat id */

export type UpdateVatIdRequest = types.ChangeVatId
export async function updateVatId (organizationId: string, billingTemplateId: string, req: UpdateVatIdRequest) {
    return patchToApi<null>(`organizations/${organizationId}/billing-templates/${billingTemplateId}/change-vat-id`, req)
}

/* Change customer number */

export type UpdateCustomerNumberRequest = types.ChangeCustomerNumber
export async function updateCustomerNumber (organizationId: string, billingTemplateId: string, req: UpdateCustomerNumberRequest) {
    return patchToApi<null>(`organizations/${organizationId}/billing-templates/${billingTemplateId}/change-customer-number`, req)
}

/* Change payment terms */

export type UpdatePaymentTermsRequest = types.ChangePaymentTerms
export async function updatePaymentTerms (organizationId: string, billingTemplateId: string, req: UpdatePaymentTermsRequest) {
    return patchToApi<null>(`organizations/${organizationId}/billing-templates/${billingTemplateId}/change-payment-terms`, req)
}

/* Change invoice reference */

export type UpdateReferenceRequest = types.ChangeReference
export async function updateReference (organizationId: string, billingTemplateId: string, req: UpdateReferenceRequest) {
    return patchToApi<null>(`organizations/${organizationId}/billing-templates/${billingTemplateId}/change-reference`, req)
}

/* Change contact data */

export type UpdateContactDataRequest = types.ChangeContactData
export async function updateContactData (organizationId: string, billingTemplateId: string, req: UpdateContactDataRequest) {
    return patchToApi<null>(`organizations/${organizationId}/billing-templates/${billingTemplateId}/change-contact-data`, req)
}

/* Change address */

export type UpdateAddressRequest = types.ChangeAddress
export async function updateAddress (organizationId: string, billingTemplateId: string, req: UpdateAddressRequest) {
    return patchToApi<null>(`organizations/${organizationId}/billing-templates/${billingTemplateId}/change-address`, req)
}

/* Change invoice description */

export type UpdateInvoiceDescriptionRequest = types.ChangeInvoiceDescription
export async function updateInvoiceDescription (organizationId: string, billingTemplateId: string, req: UpdateInvoiceDescriptionRequest) {
    return patchToApi<null>(`organizations/${organizationId}/billing-templates/${billingTemplateId}/change-invoice-description`, req)
}

/* Assign electronic delivery policy */

export type AssignElectronicDeliveryPolicyRequest = types.AssignElectronicDeliveryPolicy
export async function assignElectronicDeliveryPolicy (organizationId: string, billingTemplateId: string, req: AssignElectronicDeliveryPolicyRequest) {
    return putToApi<null>(`organizations/${organizationId}/billing-templates/${billingTemplateId}/assign-electronic-delivery-policy`, req)
}

/* Assign email delivery policy */

export type AssignEmailDeliveryPolicyRequest = types.AssignEmailDeliveryPolicy
export async function assignEmailDeliveryPolicy (organizationId: string, billingTemplateId: string, req: AssignEmailDeliveryPolicyRequest) {
    return putToApi<null>(`organizations/${organizationId}/billing-templates/${billingTemplateId}/assign-email-delivery-policy`, req)
}

/* Assign mail delivery policy */

export type AssignMailDeliveryPolicyRequest = types.AssignMailDeliveryPolicy
export async function assignMailDeliveryPolicy (organizationId: string, billingTemplateId: string, req: AssignMailDeliveryPolicyRequest) {
    return putToApi<null>(`organizations/${organizationId}/billing-templates/${billingTemplateId}/assign-mail-delivery-policy`, req)
}
